import { render } from "./AlbaniaPage.vue?vue&type=template&id=2bbc2ff9&scoped=true"
import script from "./AlbaniaPage.vue?vue&type=script&lang=js"
export * from "./AlbaniaPage.vue?vue&type=script&lang=js"

import "./AlbaniaPage.vue?vue&type=style&index=0&id=2bbc2ff9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbc2ff9"]])

export default __exports__